import { customElement, html, internalProperty, property, LitElement } from "lit-element";

@customElement('search-box')
export class SearchBoxComponent extends LitElement {
    constructor() {
        super();
    }

    createRenderRoot(): LitElement {
        return this;
    }

    @internalProperty()
    searchTerm: string = '';

    @property({ attribute: true })
    searchUrlPart = '';

    public render() {
        return html`
        <div class="searchBox header_search print_hide" role="search">
            <input @change="${this.onSearchTermChange}" @keyup="${this.onKeyUp}" class="header_search-input form-control" type="text" .value="${this.searchTerm}" maxLength="1000" placeholder="Suche" aria-label="Suche">
            <button @click="${this.onSearchButtonClicked}" class="header_search-button icon icon-search btn" type=submit value="" aria-label="Suche starten"></button>
        </div>`;
    }

    onSearchTermChange(e: any): void {
        this.searchTerm = e.srcElement.value;
    }

    onSearchButtonClicked(): void {
        window.location.href = `${this.searchUrlPart}?term=${this.searchTerm}`;
    }

    onKeyUp(e: any) {
        if (e.key === 'Enter') {
            this.onSearchButtonClicked();
        }
    }
}

declare global {
    interface HtmlElementTagNameMap {
        'search-box': SearchBoxComponent;
    }
}
